import { useAppSelector } from "@/app/hooks";
import { selectLeaseCompFieldRules } from "@/features/survey/leaseCompsSelectors";
import type { LeaseCompFieldRule } from "@/features/survey/types/survey.core.types";

export const useLeaseCompFieldRules = (): LeaseCompFieldRule[] => {
  return useAppSelector(selectLeaseCompFieldRules);
};
